import { createFileRoute } from "@tanstack/react-router";
import { PlacesPage } from "@/components/app/places/places-page";

/** Signed in but outside the staff shell, which would send a portal login straight to its own
 * portal and so never let it choose. */
export const Route = createFileRoute("/places")({
  ssr: false,
  head: () => ({ meta: [{ title: "Choose a place | People AI" }] }),
  component: PlacesPage,
});
